import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { TicketsBAndOInformationScreenBaseComponent } from '@resident-nx/shared';
import { TranslateModule } from '@ngx-translate/core';
import { TicketBandOCreationPageWebComponent } from '../ticket-creation/b-and-o/ticket-b-and-o-creation-page.component';
import { WhitelabelImageWebComponent } from '@resident-nx/web/ui';
import { ImmomioButtonComponent } from '@immomio/ui/button';

@Component({
  standalone: true,
  selector: 'rs-web-tickets-overview-b-and-o',
  styleUrls: ['./tickets-overview-b-and-o.component.scss'],
  templateUrl: './tickets-overview-b-and-o.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TranslateModule,
    ImmomioButtonComponent,
    TicketBandOCreationPageWebComponent,
    WhitelabelImageWebComponent,
  ],
})
export class TicketsBAndOInformationScreenComponent extends TicketsBAndOInformationScreenBaseComponent {
  public showBandO = signal(false);

  public showBandOTicketing(): void {
    this.showBandO.set(true);
  }
}
